import { inject, Injectable } from '@angular/core';
import { SnackbarNotificationService } from 'ngx-lib';
import { LoadingService } from './loading.service';

@Injectable({
    providedIn: 'root'
})
export class AwaiterService {
    private readonly snackbarNotificationService = inject(SnackbarNotificationService);
    private readonly loadingService = inject(LoadingService);

    async await<T>(message: string, action: Promise<T>, loadingAction?: (x: boolean) => void): Promise<T> {
        try {
            this.setLoading(true, message, loadingAction);
            return await action;
        } catch (error) {
            this.snackbarNotificationService.error(this.processError(error));
            throw error;
        } finally {
            this.setLoading(false, undefined, loadingAction);
        }
    }

    async awaitAction<T>(
        message: string,
        action: () => Promise<T>,
        loadingAction?: (x: boolean) => void
    ): Promise<T | undefined> {
        try {
            this.setLoading(true, message, loadingAction);
            return await action();
        } catch (error) {
            this.snackbarNotificationService.error(this.processError(error));
            return undefined;
        } finally {
            this.setLoading(false, undefined, loadingAction);
        }
    }

    processError(error: any): string {
        let errorMessage = '';

        if (error instanceof Error || ('message' in error && error.message)) errorMessage = error.message;

        if ('response' in error && error.response) {
            const innerError = JSON.parse(error.response);

            if ('title' in innerError && innerError.title) {
                errorMessage += `\n${innerError.title}`;
            }

            if ('Message' in innerError && innerError.Message) {
                errorMessage += `\n${innerError.Message}`;
            }

            if ('errors' in innerError && innerError.errors) {
                for (const property in innerError.errors) {
                    const propertyErrors = innerError.errors[property];
                    errorMessage += `\n  Errors for property ${property}:`;

                    for (const message of propertyErrors) {
                        errorMessage += `\n   - ${message}`;
                    }
                }
            }
        }

        return errorMessage;
    }

    private setLoading(loading: boolean, message: string | undefined, loadingAction?: (x: boolean) => void): void {
        loadingAction?.(loading);
        if (loading) {
            this.loadingService.show(message);
        } else {
            this.loadingService.hide();
        }
    }
}
